export default {

	data() {
		return {
			interpolation_type: 'provnr',
			labels_visible: false,
			samplesGeoJson: null,
		}
	},

	methods: {

        /**
        *   Let the map now that we want to listen to zoom events
        *
        */
		initiateMapListener() {
			if (this.map.getZoom() >= 15) {
				this.addLabels(this.interpolation_type)
			}

			this.map.on('zoomend', e => {
				this.mapChanged();
			});
		},

        /**
        *   For some reason the map conditions has changed
        *   So we need to check of the labels should be shown
        */
		mapChanged() {
			if (this.map.getZoom() < 15) {
				this.removeLabels()
			} else {
				this.addLabels(this.interpolation_type)
			}
		},

        /**
         *   Add labels according to the type that the user selected
         * 
         * @param {String} type 
         */
		addLabels(type) {
			if (this.labels_visible == false && this.samples != null) { // Make sure the labels are not visible
				this.samples.eachLayer(function (layer) {
					if (type != "lerhaltskartan" && layer.feature.properties[type]) {
						layer.bindTooltip(
							layer.feature.properties[type].toString(),
							{ permanent: true, direction: 'right', className: "sample-label", offset: L.point({ x: -10, y: 10 }) }
						);
					}
				});
				this.labels_visible = true
			}
		},

        /**
         *   Add the samples to the map
         *   Then add their labels to the map
         * 
         * @param {GeoJson} samples 
         */
		addSamples(samples) {
			this.samples = L.geoJson(samples, {
				pointToLayer: function (feature, latlng) {
					return L.circleMarker(latlng, {
						radius: 2,
						fillColor: 'black',
						color: 'black',
						weight: 1,
						opacity: 1,
						fillOpacity: 1
					})
				}
			}).addTo(this.map);
		},

        /**
        *   Remove the labels from the map
        *   
        */
		removeLabels() {
			if (this.labels_visible == true) { // Make sure the labels visible
				this.samples.eachLayer(function (layer) {
					layer.unbindTooltip();
				});
				this.labels_visible = false
			}
		},

        /**
         * Request interpolation of a specific polygon
         * 
         * @param {String} type 
         */
		changeSampleText(type) {
			this.interpolation_type = type
			
			if (this.samples) {
				this.samples.clearLayers()
			}
			this.labels_visible = false
			this.addSamples(this.samplesGeoJson)

			if (this.map.getZoom() >= 15) {
				this.addLabels(this.interpolation_type)
			}
		},

	}

}